module.exports = __webpack_public_path__ + "img/scuba_460.d44de709.png";